var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#231f20}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.14 22.24 32.6 45.68h7.09L32.22 22.24h-7.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45 0C20.15 0 0 20.15 0 45s20.15 45 45 45 45-20.15 45-45S69.86 0 45 0Zm10.57 71.16L41.32 50.84 23.48 71.16h-4.61l20.41-23.23-20.41-29.09h15.57l13.49 19.23 16.91-19.23h4.61L49.99 41l21.16 30.16H55.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXAlt);
export default __webpack_public_path__ + "static/media/x_alt.74f5cd6c63ad4e3055d9b222ca2f6a64.svg";
export { ForwardRef as ReactComponent };